import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemoveGeoWishFromCandidateResponse
  extends BackendResponse {}
export interface RemoveGeoWishFromCandidateParameters
  extends NextApiParams {
  municipalityId: number;
  countyId: number;
}

export const removeGeoWishFromCandidate = withNextApi<
  RemoveGeoWishFromCandidateResponse,
  RemoveGeoWishFromCandidateParameters
>("/cvp/CvpRemoveGeoWishToCandidate");
